import 'services/apex-chart-services/apex-chart-export-service';
import 'services/browser-handler-services/timeout-service';
import 'services/browser-handler-services/user-agent-service';
import 'services/content-provider';
import 'services/content-service/assessment-service';
import 'services/content-service/content-service-provider';
import 'services/content-service/course-module-service';
import 'services/content-service/customization-service';
import 'services/content-service/enrollment-service';
import 'services/content-service/initialization-service';
import 'services/content-service/module-service';
import 'services/content-service/modules-collection-service';
import 'services/content-service/page-service';
import 'services/content-service/poll-service';
import 'services/content-service/progress-service';
import 'services/content-service/resource-service';
import 'services/content-service/site-service';
import 'services/content-service/survey-service';
import 'services/course-handler-services/course-settings-service';
import 'services/course-handler-services/custom-page-service';
import 'services/course-handler-services/feedback-service';
import 'services/course-handler-services/initialization-service';
import 'services/course-handler-services/learner-profile-service';
import 'services/course-handler-services/menu-service';
import 'services/course-handler-services/navigation-service';
import 'services/course-handler-services/page-timer-service';
import 'services/course-handler-services/progress-service';
import 'services/course-handler-services/score-service';
import 'services/course-handler-services/timer-service';
/* note the video services are included in the video block bundle and should not be included here */
import 'services/course-handler-services/audio-service-howler';
import 'services/data-handler-services/ahoy-service';
import 'services/data-handler-services/assessment-service';
import 'services/data-handler-services/enrollment-data-service';
import 'services/data-handler-services/evaluation-service';
import 'services/data-handler-services/web-storage-service';
import 'services/data-handler-services/portfolio-service';
import 'services/data-handler-services/state-export-service';
import 'services/data-handler-services/survey-service';
import 'services/data-handler-services/sync-service';
import 'services/event-handler-services/animation-service';
import 'services/event-handler-services/hyperlink-service';
import 'services/event-handler-services/trigger-service';
import 'services/event-handler-services/drag-and-drop-keyboard-service';
import 'services/event-handler-services/keybinding-service';
import 'services/event-handler-services/sizing-service';
import 'services/event-handler-services/focus-service';
import 'services/homeroom/assessment-service';
import 'services/homeroom/course-module-service';
import 'services/homeroom/customization-service';
import 'services/homeroom/enrollment-service';
import 'services/homeroom/homeroom-provider';
import 'services/homeroom/initialization-service';
import 'services/homeroom/module-service';
import 'services/homeroom/modules-collection-service';
import 'services/homeroom/page-service';
import 'services/homeroom/poll-service';
import 'services/homeroom/progress-service';
import 'services/homeroom/resource-service';
import 'services/homeroom/site-service';
import 'services/homeroom/survey-service';
import 'services/loader-handler-services/tippy-loader-service';
import 'services/loader-handler-services/async-block-service';
import 'services/loader-handler-services/async-script-service';
import 'services/loader-handler-services/atom-loader';
import 'services/loader-handler-services/content-service';
import 'services/loader-handler-services/icon-load-service';
import 'services/loader-handler-services/load-service';
import 'services/loader-handler-services/locale-service';
import 'services/loader-handler-services/html-import-service';
import 'services/page-service';
import 'services/services-initializer';
import 'services/state-handler-services/state-binding-service';
import 'services/state-handler-services/state-format-service';
import 'services/state-handler-services/state-parser';
import 'services/state-handler-services/state-service';
import 'services/timer/countdown-timer';
import 'services/timer/course-timer-service';
import 'services/timer/event-manager';
import 'services/timer/timer';
import 'services/error-handler-service/error';
import 'services/error-handler-service/handler';
import 'services/error-handler-service/logger';
